let subscribers = {};

export function sub(event, callback) {
  let index;

  if (!subscribers[event]) {
      subscribers[event] = [];
  }

  index = subscribers[event].push(callback) - 1;

  return () => {
    subscribers[event].splice(index, 1);
  }
};

export function pub(event, data) {
  if (!subscribers[event]) return;

  subscribers[event].forEach(callback => {
    callback(data);
  });
}

export const EVENT_REQUEST_START = 'request-start';
export const EVENT_REQUEST_END = 'request-end';
export const EVENT_REQUEST_ERROR = 'request-error';



// WEBPACK FOOTER //
// ./src/util/pubsub.js